<template>
  <header 
    class="p2a-header" 
    role="banner">
    <img 
      v-if="campaignLogo" 
      :src="campaignLogo" 
      :alt="campaignLogoAltText"
      class="p2a-logo-header" 
    >
  </header>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "HeaderSection",
  computed: {
    ...mapState("wdyk", {
      campaignLogo: state => state.headerSettings.campaignLogo,
      campaignLogoAltText: state => state.headerSettings.campaignLogoAltText
    })
  }
};
</script>
